module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(!_vm.results) ? _c('div', {
    staticClass: "empty"
  }, [_c('p', {
    staticClass: "empty-title h5"
  }, [_vm._v("There are no VEVO results for this client")]), _vm._v(" "), (!_vm.validProfile) ? _c('div', [_c('dl', [(!_vm.okDOB) ? _c('dt', [_vm._v("Invalid date of birth")]) : _vm._e(), _vm._v(" "), (!_vm.okCountry) ? _c('dt', [_vm._v("No country")]) : _vm._e(), _vm._v(" "), (!_vm.okPassport) ? _c('dt', [_vm._v("No passport number")]) : _vm._e()])]) : _c('div', {
    staticClass: "empty-action"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Perform search")])])]) : _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-3 col-sm-12"
  }, [_vm._v("Date of search")]), _vm._v(" "), _c('div', {
    staticClass: "col-9 col-sm-12"
  }, [_vm._v(_vm._s(new Date(_vm.results.date).toLocaleDateString('en-gb')))])]), _vm._v(" "), _vm._l((_vm.resultFields), function(desc, field) {
    return _c('div', {
      staticClass: "columns"
    }, [(_vm.results[field]) ? _c('div', {
      staticClass: "col-3 col-sm-12"
    }, [_vm._v(_vm._s(desc))]) : _vm._e(), _vm._v(" "), (_vm.results[field]) ? _c('div', {
      staticClass: "col-9 col-sm-12"
    }, [_vm._v(_vm._s(_vm.results[field]))]) : _vm._e()])
  }), _vm._v(" "), (_vm.results.conditions) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-3 col-sm-12"
  }, [_vm._v("Visa conditions")]), _vm._v(" "), _c('div', {
    staticClass: "col-9 col-sm-12"
  }, _vm._l((_vm.results.conditions), function(c) {
    return _c('div', {
      domProps: {
        "innerHTML": _vm._s(c)
      }
    })
  }), 0)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: {
      loading: _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Update results")]), _vm._v(" "), (_vm.showCalMsg) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Expiry date in calendar")]) : _vm._e()], 2), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.message) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), (_vm.errormsg) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.errormsg))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a42bc91"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/clientvevo.vue
// module id = 491
// module chunks = 1